import React from "react";
import { groupLabel } from "./setupUi";

/**
 * Right-side panel: overall progress and one entry per service group; clicking one shows only that group.
 * ``showConnections`` adds the API Connections entry (staff only).
 */
function SetupGroupsPanel({ setup, group, expanded, onPickGroup, showConnections = true }) {
  const overall = setup.Progress?.Pct ?? 0;

  return (
    <nav className="dmc-card dms-side" aria-label="Setup groups">
      <button
        type="button"
        className={`dms-side__head dms-side__all${group === "all" ? " is-active" : ""}`}
        aria-pressed={group === "all"}
        onClick={() => onPickGroup("all")}
      >
        <span className="dms-side__name">All steps</span>
        <span className="dms-side__pct">{overall}%</span>
        <span className="dms-side__meta">
          {setup.Progress?.Steps_Done ?? 0} of {setup.Progress?.Steps_Total ?? 0} done across all groups
        </span>
      </button>

      {setup.Categories.map((c) => {
        const pct = c.Progress?.Pct ?? 0;
        const done = c.Progress?.Steps_Done ?? 0;
        const total = c.Progress?.Steps_Total ?? 0;
        return (
          <section
            key={c.Category_Id}
            className={`dms-side__group${expanded === c.Category_Id ? " is-expanded" : ""}${pct === 100 ? " is-complete" : ""}`}
          >
            <button
              type="button"
              className={`dms-side__head${group === c.Category_Id ? " is-active" : ""}`}
              aria-pressed={group === c.Category_Id}
              onClick={() => onPickGroup(c.Category_Id)}
              title={c.Description || undefined}
            >
              <span className="dms-side__name">{groupLabel(c)}</span>
              <span className="dms-side__pct">{pct}%</span>
              <span className="dms-side__meta">{total ? `${done} of ${total} done` : "Nothing to do"}</span>
            </button>
          </section>
        );
      })}

      {showConnections ? (
        <section className={`dms-side__group${expanded === "connections" ? " is-expanded" : ""}`}>
          <button
            type="button"
            className={`dms-side__head${group === "connections" ? " is-active" : ""}`}
            aria-pressed={group === "connections"}
            onClick={() => onPickGroup("connections")}
            title="Pages, channels, ad accounts and WhatsApp connected to Cloud Office"
          >
            <span className="dms-side__name">API Connections</span>
            <span className="dms-side__pct dms-side__pct--muted">Optional</span>
            <span className="dms-side__meta">Connect now or any time later</span>
          </button>
        </section>
      ) : null}
    </nav>
  );
}

export default SetupGroupsPanel;
